import { useQuery } from '@apollo/client';
import { useTypedParams } from 'react-router-typesafe-routes';
import { useCallback, useMemo } from 'react';
import { FRAGMENTS } from '../../../lib/ROUTES';
import { MediaPostListByTagDocument } from '../gql/MediaPostListByTag.document';
import { FILTERED_POSTS_LIMIT } from '../../../components/FilterView';
import { ignoreReject } from '../../../lib/ignoreReject';

export const useFilterByTag = () => {
  const { id } = useTypedParams(FRAGMENTS.WITH_ID);

  const variables = useMemo(
    () => ({
      tagAlias: id,
      mediaPostLimit: FILTERED_POSTS_LIMIT,
    }),
    [id],
  );

  const {
    data: currentData,
    previousData,
    fetchMore,
    loading,
  } = useQuery(MediaPostListByTagDocument, {
    variables,
    fetchPolicy: 'cache-first',
  });

  const data = currentData || previousData;

  const onFetchMore = useCallback(() => {
    if (data?.mediaPosts.pageInfo.hasNextPage) {
      void ignoreReject(
        fetchMore({
          variables: {
            ...variables,
            mediaPostCursor: data.mediaPosts.pageInfo.endCursor,
          },
        }),
      );
    }
  }, [data?.mediaPosts.pageInfo.endCursor, data?.mediaPosts.pageInfo.hasNextPage, fetchMore, variables]);

  return { data, loading, onFetchMore };
};
